import React from 'react';

interface BootPulseProps {
  /** Accessible name announced to assistive tech (status is never color-only). */
  label?: string;
}

/**
 * QDS "boot / loading" indicator: a centered pulsing sky dot.
 * Shared by BrandedLayout and any page-level loading state.
 */
export const BootPulse: React.FC<BootPulseProps> = ({ label = 'Loading' }) => (
  <div className="qds-boot-pulse-wrap">
    <span className="qds-boot-pulse" role="status" aria-label={label} />
  </div>
);
